/**
 * The sentinel value for the "Manage pricing profiles…" row that closes each
 * profile dropdown and opens the profile editor.
 *
 * Modelled as a real option rather than a button glued under the list so it
 * keeps the dropdown's own keyboard handling and focus management. It is never
 * a valid stored value: every `onValueChange` must intercept it and return
 * before writing to the form.
 */
export const MANAGE_PROFILES_VALUE = '__MANAGE_PROFILES__';

export const MANAGE_PROFILES_LABEL = 'Manage pricing profiles…';
